export default "__VITE_ASSET__b99b7ba8__"